import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { fetchUserInfo } from "../../auth/authSlice";
import { fetchStudents } from "../../student/studentSlice";
import { isUnlimitedCapacity } from "../../../utils/planUtils";

import MonthlySummaryCard from "./MonthlySummaryCard";
import StudentCapacityBox from "./StudentCapacityBox";
import LogoUploadBox from "./LogoUploadBox";
import { CONTAINER_MAX_WIDTH } from "../../../styles/layout";

const AcademyManagementPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserInfo());
    dispatch(fetchStudents());
  }, [dispatch]);

  const { allStudents } = useSelector((state) => state.student);
  const { user } = useSelector((state) => state.auth);

  const isMobile =
    Math.min(window.innerWidth, window.screen.width) <= 768;

  const textList = [
    { keyText: "이용중인 서비스", valueText: user.plan.toUpperCase(), highlight: true },
    {
      keyText: "등록 가능 학생 수",
      valueText: isUnlimitedCapacity(user.max_student_capacity) ? "무제한" : `${user.max_student_capacity}명`,
    },
    { keyText: "현재 등록 학생 수", valueText: `${allStudents.length}명` },
    {
      keyText: "잔여 등록 학생 수",
      valueText: isUnlimitedCapacity(user.max_student_capacity)
        ? "무제한"
        : `${user.max_student_capacity - allStudents.length}명`,
    },
  ];

  return (
    <div
      style={{
        maxWidth: `${CONTAINER_MAX_WIDTH}px`,
        margin: "0 auto",
        padding: isMobile ? "16px 14px 40px" : "24px 28px 60px",
      }}
    >
      <MonthlySummaryCard isMobile={isMobile} />
      <div
        className="section-title"
        style={{
          marginBottom: "22px",
        }}
      >
        로고 및 카카오채널 관리
      </div>

      {/* 학원 정보 요약 카드 — 위로 올림 */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(4, 1fr)",
          gap: isMobile ? "10px" : "14px",
          marginBottom: "22px",
        }}
      >
        {textList.map((text, index) => (
          <StudentCapacityBox
            key={index}
            keyText={text.keyText}
            valueText={text.valueText}
            highlight={text.highlight}
          />
        ))}
      </div>

      {/* 로고 업로드 섹션 */}
      <div
        style={{
          backgroundColor: "#FFF",
          borderRadius: "18px",
          border: "1px solid #E6EDEC",
          boxShadow: "0 10px 30px -22px rgba(20,40,50,.22)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            padding: "18px 22px 0",
            fontSize: "1rem",
            fontWeight: 800,
            color: "#0E141B",
            letterSpacing: "-0.01em",
          }}
        >
          학원 로고 변경
        </div>
        <LogoUploadBox />
      </div>
    </div>
  );
};

export default AcademyManagementPage;
